/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Main_MenuInputs */



/**
* | output |
* | --- |
* | "Main menu" |
*
* @param {Main_MenuInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const main_menu = /** @type {((inputs?: Main_MenuInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Main_MenuInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Menu principal")
	if (locale === "de") return /** @type {LocalizedString} */ ("Hauptmenü")
	if (locale === "it") return /** @type {LocalizedString} */ ("Menu principale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Главное меню")
	if (locale === "es") return /** @type {LocalizedString} */ ("Menú principal")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("主菜单")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メインメニュー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मुख्य मेन्यू")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Menu principal")
	return /** @type {LocalizedString} */ ("Main menu")
});